import { Context } from 'effect';
import type { Effect, HashSet, Layer, Schema } from 'effect';

import type {
  CookieAccessError,
  CookieGetError,
  CookieRemoveError,
  CookieSetError,
} from '../../data/error/cookies';
import type { CookiesStore } from '../cookies/CookiesStore';
import { ContextTag } from '../context';

export type AlertMessagesDismissedService = {
  readonly getDismissedIds: Effect.Effect<
    HashSet.HashSet<string>,
    CookieGetError | CookieAccessError
  >;
  readonly addDismissedId: (
    id: string
  ) => Effect.Effect<
    void,
    CookieGetError | CookieSetError | CookieAccessError | Schema.SchemaError
  >;
  readonly removeDismissedId: (
    id: string
  ) => Effect.Effect<
    void,
    CookieGetError | CookieSetError | CookieAccessError | Schema.SchemaError
  >;
  readonly clearDismissedIds: Effect.Effect<void, CookieRemoveError | CookieAccessError>;
};

export class AlertMessagesDismissed extends Context.Service<
  AlertMessagesDismissed,
  AlertMessagesDismissedService
>()(ContextTag.AlertMessagesDismissed) {
  declare static Live: Layer.Layer<AlertMessagesDismissed, never, CookiesStore>;
}
